<template>
  <div>
    <textarea
      class="rp-input rp-textarea is-small"
      v-bind:class="{ 'is-danger': status }"
      v-bind:placeholder="inputData.placeholder"
      v-on:blur="validateInput()"
      v-on:input="updateValue($event.target.value)"
      v-bind:value="value"
      v-bind:maxlength="inputData.maxlength"
    >
    </textarea>

    <div class="validation-text" v-if="status === true">
      {{ t.pleaseInsertText }}
    </div>
  </div>
</template>

<script>
import { Cart } from '@/store/Cart'

export default {
  name: 'TextareaInput',
  props: {
    value: String,
    inputData: {
      type: Object,
      default: () => {
        return {
          id: 1,
          type: 'textarea',
          required: '0',
          placeholder: 'placeholder',
          maxlength: null,
          option: []
        }
      }
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          pleaseInsertText: 'Please insert data'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          pleaseInsertText: 'กรุณากรอกข้อมูล'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          pleaseInsertText: 'Vui lòng nhập dữ liệu'
        }
      }
    }
  },
  data () {
    return {
      status: false
    }
  },
  methods: {
    validateInput () {
      let result = true

      if (this.value === '' && this.inputData.required === '1') {
        this.status = true
        result = false

        return result
      } else {
        this.status = false
      }
      return result
    },
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.validation-text {
  color: red;
  font-size: 0.75em;
}
</style>



// WEBPACK FOOTER //
// src/components/share/form/TextareaInput.vue